import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { tokens } from "../../theme";
import Headeer from "../../components/Headeer";
import DoctorService from "../../services/doctorService";
import StatsService from "../../services/doctorServices/StatsService";
import DoctorPerformanceChartPanel from "../../components/Stats/DoctorPerformanceChartPanel";

export default function TeamStatistics() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation("team");
  const navigate = useNavigate();
  const doctorService = useMemo(() => new DoctorService(), []);
  const statsService = useMemo(() => new StatsService(), []);

  const [doctors, setDoctors] = useState([]);

  /** Giriş yapan doktor — yalnızca bu kullanıcının doğrudan eklediği/davet ettiği doktorlar dropdown’da */
  const loggedInDoctorId = useMemo(() => {
    try {
      const u = JSON.parse(localStorage.getItem("user") || "{}");
      if (u?.id != null) return String(u.id);
    } catch {
      /* ignore */
    }
    const d = localStorage.getItem("doctorId");
    if (d && d !== "null" && d !== "undefined") return String(d);
    return null;
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await doctorService.getAllDoctor();
        setDoctors(Array.isArray(response) ? response : []);
      } catch (e) {
        console.error(e);
        setDoctors([]);
      }
    };
    load();
  }, [doctorService]);

  const doctorsDirectSubordinates = useMemo(() => {
    if (!loggedInDoctorId) return [];
    return doctors.filter((d) => {
      if (d.created_by == null || d.created_by === "") return false;
      return String(d.created_by) === loggedInDoctorId;
    });
  }, [doctors, loggedInDoctorId]);

  const doctorChartOptions = useMemo(
    () =>
      doctorsDirectSubordinates.map((d) => ({
        id: d.id,
        label: `${d.name || ""} ${d.surname || ""}`.trim() || String(d.id),
      })),
    [doctorsDirectSubordinates]
  );

  const fetchDoctorStats = useCallback((params) => statsService.getDoctorStats(params), [statsService]);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
        }}
      >
        <Headeer title={t("teamStatistics")} subtitle={t("teamStatisticsSubtitle")} />
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/team")}
          sx={{
            alignSelf: { xs: "flex-start", sm: "center" },
            borderColor: colors.blueAccent[500],
            color: colors.grey[100],
            textTransform: "none",
            fontWeight: 600,
            px: 2,
            py: 1,
            borderRadius: 2,
            "&:hover": {
              borderColor: colors.blueAccent[400],
              backgroundColor: `${colors.blueAccent[800]}33`,
            },
          }}
        >
          {t("backToTeam")}
        </Button>
      </Box>

      <DoctorPerformanceChartPanel
        doctorOptions={doctorChartOptions}
        fetchStats={fetchDoctorStats}
        sx={{
          maxWidth: { xs: "100%", lg: "min(100%, 1680px)" },
        }}
      />
    </Box>
  );
}
